<script>
  import FitLogLayout from "./layouts/FitLogLayout.svelte";
  import MainLayout from "./layouts/MainLayout.svelte";
  import Blog from "./pages/BlogPage.svelte";
  import FitLog from "./pages/FitLogPage.svelte";
  import Main from "./pages/Main.svelte";

  import { Route, Router } from "svelte-routing";
  export let url = ""; //This property is necessary declare to avoid ignore the Router

  // On page load or when changing themes, best to add inline in `head` to avoid FOUC
  let theme = "dark";

  const setTheme = (newTheme) => {
    theme = newTheme;
    localStorage.theme = newTheme;
    document.documentElement.style.setProperty("--theme", newTheme);
  };

  if ("theme" in localStorage) setTheme(localStorage.theme);
  else {
    // new visitor
    // localStorage.theme = window.matchMedia("(prefers-color-scheme: dark)").matches
    // 	? "dark"
    // 	: "light";
    setTheme("dark"); // force dark theme cuz its nicer
  }

  const toggleTheme = () => setTheme(theme === "dark" ? "light" : "dark");
</script>

<div class="{theme === 'dark' ? 'dark' : ''} flex flex-col min-h-screen">
  <Router {url}>
    <!-- Main route with navbar layout -->
    <Route path="/" let:params>
      <MainLayout bind:theme {toggleTheme}>
        <Main bind:theme />
      </MainLayout>
    </Route>

    <!-- Rust page route with standalone layout (no navbar) -->
    <Route path="/fitlog" let:params>
      <FitLogLayout>
        <FitLog {theme} />
      </FitLogLayout>
    </Route>
    <Route path="/blog" let:params>
      <FitLogLayout>
        <Blog />
      </FitLogLayout>
    </Route>
  </Router>
</div>
